import React from "react";
import { Formik, Form, ErrorMessage, Field } from "formik";
import {
  DatePicker,
  TimePicker,
  Select,
  Upload,
  Button,
  Divider,
  Row,
  Col,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import AddAlertValidationSchema from "./AddAlertValidationSchema";

//React Icons
import { FaUpload } from "react-icons/fa6";

const AddAlertForm = ({
  handleAddAlert,
  alertoptions,
  locationoptions,
  cameraoptions,
  alertsAssignedMailsoptions,
  esscalationEmailsoptions,
  imageFileList,
  beforeUpload,
  handleChange,
  handleRemove,
  image,
}) => {
  return (
    <Formik
      initialValues={{
        date: "",
        time: "",
        alert: "",
        camera: "",
        status: "",
        location: "",
        alertsAssignedMails: [],
        escalationEmails: [],
        image: "",
      }}
      validationSchema={AddAlertValidationSchema}
      onSubmit={handleAddAlert}
    >
      {({ errors, touched, setFieldValue }) => (
        <Form>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <DatePicker
                style={{ width: "100%" }}
                onChange={(date, dateString) =>
                  setFieldValue("date", dateString)
                }
                placeholder="Select Date"
              />
              <ErrorMessage
                name="date"
                component="div"
                style={{ color: "red" }}
              />
            </Col>
            <Col span={12}>
              <TimePicker
                style={{ width: "100%" }}
                onChange={(time, timeString) =>
                  setFieldValue("time", timeString)
                }
                placeholder="Select Time"
              />
              <ErrorMessage
                name="time"
                component="div"
                style={{ color: "red" }}
              />
            </Col>
          </Row>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Select
                placeholder="Select Alert"
                style={{ width: "100%" }}
                options={alertoptions}
                onChange={(value) => setFieldValue("alert", value)}
              />
              <ErrorMessage
                name="alert"
                component="div"
                style={{ color: "red" }}
              />
            </Col>
            <Col span={12}>
              <Select
                placeholder="Select Location"
                style={{ width: "100%" }}
                options={locationoptions}
                onChange={(value) => setFieldValue("location", value)}
              />
              <ErrorMessage
                name="location"
                component="div"
                style={{ color: "red" }}
              />
            </Col>
          </Row>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Select
                placeholder="Select Camera"
                style={{ width: "100%" }}
                options={cameraoptions}
                onChange={(value) => setFieldValue("camera", value)}
              />
              <ErrorMessage
                name="camera"
                component="div"
                style={{ color: "red" }}
              />
            </Col>
            <Col span={12}>
              <Select
                placeholder="Select Status"
                style={{ width: "100%" }}
                options={[
                  { value: "Open", label: "Open" },
                  { value: "Close", label: "Close" },
                ]}
                onChange={(value) => setFieldValue("status", value)}
              />
              <ErrorMessage
                name="status"
                component="div"
                style={{ color: "red" }}
              />
            </Col>
          </Row>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Select
                placeholder="Assigned to"
                style={{ width: "100%" }}
                mode="multiple"
                options={alertsAssignedMailsoptions}
                onChange={(value) =>
                  setFieldValue("alertsAssignedMails", value)
                }
              />
              <ErrorMessage
                name="alertsAssignedMails"
                component="div"
                style={{ color: "red" }}
              />
            </Col>
            <Col span={12}>
              <Select
                placeholder="Escalated to"
                style={{ width: "100%" }}
                mode="multiple"
                options={esscalationEmailsoptions}
                onChange={(value) => setFieldValue("escalationEmails", value)}
              />
              <ErrorMessage
                name="escalationEmails"
                component="div"
                style={{ color: "red" }}
              />
            </Col>
          </Row>
          <Divider />
          <Upload
            name="image"
            listType="picture"
            action="https://godrej.app-assertai.com:5000/Other/upload-image-to-S3"
            beforeUpload={beforeUpload}
            onChange={(info) => {
              handleChange(info);
              if (info.file.status === "done") {
                setFieldValue("image", info.file.response.url || image);
              }
            }}
            onRemove={handleRemove}
            fileList={imageFileList}
          >
            {imageFileList.length >= 1 ? null : (
              <div className="flex items-center gap-2 bg-teal-700 p-2  rounded-lg">
                <FaUpload className="text-white" />
                <Button type="primary" className="bg-teal-700" >
                  Upload Image
                </Button>
              </div>
            )}
          </Upload>
          <Field name="image" type="hidden" value={image} />
          <ErrorMessage name="image" component="div" style={{ color: "red" }} />
          <Divider />
          <div className="flex justify-center">
            <Button
              type="primary"
              // block
              htmlType="submit"
              className="bg-teal-700 w-1/2"
            >
              Add Alert
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddAlertForm;
